import { useState } from "react";
import { faqs } from "@/mocks/communityData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" aria-label="常见问题" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-x grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="tag-primary"><i className="ri-questionnaire-line"></i>F.A.Q</span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            你好奇的<span className="text-primary-500">都有答案</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            第一次来吃瓜聚集？关于浏览、发言、参与话题的常见疑问都在这里。没找到答案？直接去版块发帖问在线瓜友，大家都很乐意帮你。
          </p>
          <div className="mt-6 flex flex-col gap-3 rounded-2xl bg-background-100 p-5">
            <p className="text-xs font-bold uppercase tracking-wide text-secondary-700">找不到答案？</p>
            <a href="#plaza" className="btn-secondary justify-start">
              <i className="ri-send-plane-line mr-2"></i>
              去话题广场提问
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={
                  "card overflow-hidden transition-all duration-300 " +
                  (open ? "ring-primary-300" : "hover:ring-background-300")
                }
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className={"flex items-center gap-3 text-sm font-bold md:text-base " + (open ? "text-primary-700" : "text-foreground-950")}>
                    <span className={"flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-black " + (open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600")}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <span className={"shrink-0 text-lg transition-transform duration-300 " + (open ? "rotate-45 text-primary-500" : "text-foreground-400")}>
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div className={"overflow-hidden transition-[max-height] duration-300 " + (open ? "max-h-96" : "max-h-0")}>
                  <p className="px-5 pb-5 pl-[4.5rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[4.75rem]">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}